(function () {
  'use strict';

  function _initPTQ(cfg) {
    var SECTION_ID           = cfg.id;
    var PRODUCTS_PER_PAGE    = cfg.perPage;
    var SHOW_PAGINATION      = cfg.showPagination;
    var PAGINATION_INFO_TEXT = cfg.paginationText;
    var SHOW_REVIEWS         = cfg.showReviews;
    var REVIEWS_LABEL        = cfg.reviewsLabel;
    var STARS_COLOR          = cfg.starsColor;
    var STARS_EMPTY_COLOR    = cfg.starsEmptyColor;
    var ADDING_TEXT          = cfg.addingText;
    var ADDED_TEXT           = cfg.addedText;
    var moneyFormatter       = new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency });

    if (window['ptqAbortController_' + SECTION_ID]) {
      window['ptqAbortController_' + SECTION_ID].abort();
    }
    window['ptqAbortController_' + SECTION_ID] = new AbortController();
    var abortSignal = window['ptqAbortController_' + SECTION_ID].signal;

    var currentProduct     = null;
    var selectedVariantId  = null;
    var isQuickViewOpen    = false;
    var isQuickViewLoading = false;
    var isModalAdding      = false;

    function run() {

      // ---- swatch color init ----
      var root3 = document.getElementById('ptqSection-' + SECTION_ID);
      if (root3) {
        function normalize(value) { return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-'); }
        function colorFor(value) {
          var key = normalize(value);
          if (key.indexOf('saxony') !== -1 || key.indexOf('saxon') !== -1 || key.indexOf('bleu-saxon') !== -1) return '#2E6EA6';
          if (key.indexOf('marine') !== -1 || key.indexOf('navy') !== -1) return '#243B53';
          if (key.indexOf('bleu') !== -1 || key.indexOf('blue') !== -1) return '#2E6EA6';
          if (key.indexOf('noir') !== -1 || key.indexOf('black') !== -1) return '#111111';
          if (key.indexOf('blanc') !== -1 || key.indexOf('white') !== -1) return '#FFFFFF';
          if (key.indexOf('gris') !== -1 || key.indexOf('gray') !== -1 || key.indexOf('grey') !== -1) return '#D6DCE3';
          if (key.indexOf('rouge') !== -1 || key.indexOf('red') !== -1) return '#E52525';
          if (key.indexOf('rose') !== -1 || key.indexOf('pink') !== -1) return '#E64A9B';
          if (key.indexOf('violet') !== -1 || key.indexOf('purple') !== -1) return '#9B5DE5';
          if (key.indexOf('orange') !== -1) return '#F5A11A';
          if (key.indexOf('jaune') !== -1 || key.indexOf('yellow') !== -1) return '#F2C94C';
          if (key.indexOf('vert') !== -1 || key.indexOf('green') !== -1) return '#4F6F3D';
          if (key.indexOf('marron') !== -1 || key.indexOf('brown') !== -1) return '#8A5A3C';
          if (key.indexOf('beige') !== -1 || key.indexOf('camel') !== -1 || key.indexOf('tan') !== -1) return '#D89B5C';
          if (key.indexOf('camouflage') !== -1) return '#6B7C43';
          if (key.indexOf('kaki') !== -1) return '#8E9B5C';
          return '';
        }
        function applySwatchColors() {
          root3.querySelectorAll('.ptq-swatch[title]').forEach(function (swatch) {
            var color = colorFor(swatch.getAttribute('title'));
            if (color) swatch.style.backgroundColor = color;
          });
        }
        applySwatchColors();
        document.addEventListener('shopify:section:load', applySwatchColors);
      }

      // ---- swatch interactions (conditional on enableSwatchClick) ----
      var root2 = cfg.enableSwatchClick ? document.getElementById('ptqSection-' + SECTION_ID) : null;
      if (root2) {
        var productCache = {};
        function formatMoney(cents) { return moneyFormatter.format((Number(cents) || 0) / 100); }
        function productUrl(card) {
          var link = card.querySelector('.ptq-product-title a') || card.querySelector('.ptq-image-wrapper a');
          return link ? link.getAttribute('href') : '';
        }
        function getProduct(url) {
          var rawPath = String(url || '').split('?')[0].replace(/\/$/, '');
          var match = rawPath.match(/\/products\/([^/]+)/);
          var handle = match ? match[1] : '';
          if (!handle) return Promise.reject();
          var path = '/products/' + handle;
          if (productCache[path]) return Promise.resolve(productCache[path]);
          return fetch(path + '.js').then(function (r) { return r.json(); }).then(function (product) {
            productCache[path] = product;
            return product;
          });
        }
        function colorOptionIndex(product) {
          var options = product.options || [];
          for (var i = 0; i < options.length; i++) {
            var option = options[i];
            var name = String(option && option.name ? option.name : option || '').toLowerCase();
            if (name === 'color' || name === 'couleur' || name.indexOf('couleur') !== -1 || name === 'configuration') return i;
          }
          return -1;
        }
        function sameValue(a, b) { return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase(); }
        function applyVariant(card, swatch, variant) {
          card.querySelectorAll('.ptq-swatch').forEach(function (item) { item.classList.remove('active'); });
          swatch.classList.add('active');
          var addBtn = card.querySelector('.ptq-add-btn');
          if (addBtn && variant.id) { addBtn.dataset.variantId = variant.id; addBtn.disabled = !variant.available; }
          var primaryImage = card.querySelector('.ptq-image-primary');
          if (primaryImage && variant.featured_image && variant.featured_image.src) {
            primaryImage.src = variant.featured_image.src;
            primaryImage.removeAttribute('srcset');
          }
          var price   = card.querySelector('.ptq-price-current');
          var compare = card.querySelector('.ptq-price-compare');
          if (price) price.textContent = formatMoney(variant.price);
          if (compare) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compare.textContent = formatMoney(variant.compare_at_price);
              compare.style.display = '';
            } else { compare.textContent = ''; compare.style.display = 'none'; }
          }
        }
        root2.querySelectorAll('.ptq-swatch[title]').forEach(function (swatch) {
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('tabindex', '0');
          swatch.setAttribute('aria-label', 'Choisir la couleur ' + swatch.getAttribute('title'));
        });
        root2.addEventListener('click', function (event) {
          var swatch = event.target.closest('.ptq-swatch[title]');
          if (!swatch || !root2.contains(swatch)) return;
          event.preventDefault(); event.stopPropagation();
          var card = swatch.closest('.ptq-card');
          if (!card) return;
          var value = swatch.getAttribute('title');
          getProduct(productUrl(card)).then(function (product) {
            var optionIndex = colorOptionIndex(product);
            if (optionIndex < 0) return;
            var variant = (product.variants || []).find(function (item) { return sameValue(item.options[optionIndex], value); });
            if (variant) applyVariant(card, swatch, variant);
          }).catch(function () {});
        }, true);
        root2.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          var swatch = event.target.closest('.ptq-swatch[title]');
          if (!swatch || !root2.contains(swatch)) return;
          event.preventDefault();
          swatch.click();
        });
      }

      // ---- main quickview logic ----
      const sectionEl = document.getElementById('ptqSection-' + SECTION_ID);
      if (!sectionEl) return;
      const modal = document.getElementById('ptqModal-' + SECTION_ID);
      if (!modal) return;
      if (modal.dataset.initialized === 'true') return;
      modal.dataset.initialized = 'true';

      const overlay             = modal.querySelector('.ptq-modal-overlay');
      const closeBtn            = modal.querySelector('.ptq-modal-close');
      const mainImage           = document.getElementById('ptqMainImage-' + SECTION_ID);
      const thumbnailsContainer = document.getElementById('ptqThumbnails-' + SECTION_ID);
      const titleEl             = document.getElementById('ptqTitle-' + SECTION_ID);
      const priceEl             = document.getElementById('ptqPrice-' + SECTION_ID);
      const reviewsEl           = document.getElementById('ptqReviews-' + SECTION_ID);
      const descriptionEl       = document.getElementById('ptqDescription-' + SECTION_ID);
      const variantsEl          = document.getElementById('ptqVariants-' + SECTION_ID);
      const quantityInput       = document.getElementById('ptqQuantity-' + SECTION_ID);
      const addToCartBtn        = document.getElementById('ptqAddToCart-' + SECTION_ID);
      const viewFullLink        = document.getElementById('ptqViewFull-' + SECTION_ID);

      function fmtMoney(cents) { return moneyFormatter.format((Number(cents) || 0) / 100); }
      function getSizedImageUrl(url, size) {
        if (!url) return '';
        return url.replace(/\.(jpg|jpeg|png|gif|webp)/, '_' + size + '.$1');
      }

      function initPagination(container) {
        if (!SHOW_PAGINATION) return;
        const grid                 = container.querySelector('[data-grid-container]');
        const paginationContainer  = container.querySelector('[data-pagination-container]');
        const pageNumbersContainer = container.querySelector('[data-page-numbers]');
        const paginationInfo       = container.querySelector('[data-pagination-info]');
        const prevBtn              = container.querySelector('[data-page-action="prev"]');
        const nextBtn              = container.querySelector('[data-page-action="next"]');
        if (!grid || !paginationContainer) return;
        const allCards      = Array.from(grid.querySelectorAll('.ptq-card'));
        const totalProducts = allCards.length;
        const totalPages    = Math.ceil(totalProducts / PRODUCTS_PER_PAGE);
        if (totalPages <= 1) {
          paginationContainer.style.display = 'none';
          if (paginationInfo) paginationInfo.style.display = 'none';
          allCards.forEach(card => card.classList.remove('ptq-hidden'));
          return;
        }
        paginationContainer.style.display = 'flex';
        if (paginationInfo) paginationInfo.style.display = 'block';
        let currentPage = 1;
        function showPage(page) {
          currentPage = page;
          const start = (page - 1) * PRODUCTS_PER_PAGE;
          const end   = start + PRODUCTS_PER_PAGE;
          allCards.forEach((card, index) => {
            if (index >= start && index < end) card.classList.remove('ptq-hidden');
            else card.classList.add('ptq-hidden');
          });
          prevBtn.disabled = page === 1;
          nextBtn.disabled = page === totalPages;
          renderPageNumbers();
          if (paginationInfo) {
            paginationInfo.textContent = PAGINATION_INFO_TEXT
              .replace('{start}', start + 1).replace('{end}', Math.min(end, totalProducts)).replace('{total}', totalProducts);
          }
          sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        function renderPageNumbers() {
          pageNumbersContainer.innerHTML = '';
          const maxVisible = window.innerWidth < 768 ? 5 : 7;
          let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
          let endPage   = Math.min(totalPages, startPage + maxVisible - 1);
          if (endPage - startPage < maxVisible - 1) startPage = Math.max(1, endPage - maxVisible + 1);
          if (startPage > 1) {
            pageNumbersContainer.appendChild(createPageButton(1));
            if (startPage > 2) { const e = document.createElement('span'); e.className = 'ptq-page-ellipsis'; e.textContent = '...'; pageNumbersContainer.appendChild(e); }
          }
          for (let i = startPage; i <= endPage; i++) pageNumbersContainer.appendChild(createPageButton(i));
          if (endPage < totalPages) {
            if (endPage < totalPages - 1) { const e = document.createElement('span'); e.className = 'ptq-page-ellipsis'; e.textContent = '...'; pageNumbersContainer.appendChild(e); }
            pageNumbersContainer.appendChild(createPageButton(totalPages));
          }
        }
        function createPageButton(pageNum) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ptq-page-number' + (pageNum === currentPage ? ' active' : '');
          btn.textContent = pageNum;
          btn.addEventListener('click', () => showPage(pageNum));
          return btn;
        }
        prevBtn.addEventListener('click', () => { if (currentPage > 1) showPage(currentPage - 1); });
        nextBtn.addEventListener('click', () => { if (currentPage < totalPages) showPage(currentPage + 1); });
        showPage(1);
      }

      sectionEl.querySelectorAll('.ptq-products-container').forEach(initPagination);

      const tabs       = sectionEl.querySelectorAll('.ptq-tab');
      const containers = sectionEl.querySelectorAll('.ptq-products-container');
      tabs.forEach(tab => {
        tab.addEventListener('click', function () {
          const index = this.dataset.collectionIndex;
          tabs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
          containers.forEach(c => {
            c.classList.remove('active');
            if (c.dataset.collectionIndex === index) { c.classList.add('active'); initPagination(c); }
          });
        });
      });

      function buildStarsHTML(ratingValue, ratingMax, ratingCount) {
        if (!ratingValue || ratingValue <= 0) return '';
        const max = ratingMax > 0 ? ratingMax : 5;
        const pct = (ratingValue / max) * 100;
        let html = '<div class="ptq-reviews">';
        html += '<div class="ptq-stars" aria-label="' + ratingValue + ' sur ' + max + '">';
        html += '<span class="ptq-stars-bg" style="color:' + STARS_EMPTY_COLOR + '; font-size:18px; letter-spacing:3px;">★★★★★</span>';
        html += '<span class="ptq-stars-fg" style="width:' + pct + '%; color:' + STARS_COLOR + '; font-size:18px; letter-spacing:3px;">★★★★★</span>';
        html += '</div>';
        if (ratingCount > 0) html += '<span class="ptq-reviews-count">(' + ratingCount + ' ' + REVIEWS_LABEL + ')</span>';
        html += '</div>';
        return html;
      }

      function openQuickView(handle) {
        if (isQuickViewLoading || isQuickViewOpen) return;
        isQuickViewLoading = true;
        const cardBtn = sectionEl.querySelector('.ptq-quickview-btn[data-product-handle="' + handle + '"]');
        let cardRating = 0, cardRatingMax = 5, cardRatingCount = 0;
        if (cardBtn) {
          const card = cardBtn.closest('.ptq-card');
          if (card) {
            const starsEl = card.querySelector('.ptq-stars');
            if (starsEl) {
              const parts = (starsEl.getAttribute('aria-label') || '').split(' sur ');
              if (parts.length === 2) { cardRating = parseFloat(parts[0]) || 0; cardRatingMax = parseFloat(parts[1]) || 5; }
            }
            const countEl = card.querySelector('.ptq-reviews-count');
            if (countEl) { const match = countEl.textContent.match(/\((\d+)/); if (match) cardRatingCount = parseInt(match[1]) || 0; }
          }
        }
        fetch('/products/' + handle + '.js')
          .then(response => response.json())
          .then(product => {
            currentProduct = product;
            titleEl.textContent = product.title;
            if (product.compare_at_price && product.compare_at_price > product.price) {
              priceEl.innerHTML = fmtMoney(product.price) + '<span class="compare">' + fmtMoney(product.compare_at_price) + '</span>';
            } else { priceEl.innerHTML = fmtMoney(product.price); }
            if (SHOW_REVIEWS && cardRating > 0) {
              reviewsEl.innerHTML = buildStarsHTML(cardRating, cardRatingMax, cardRatingCount);
              reviewsEl.style.display = '';
            } else { reviewsEl.innerHTML = ''; reviewsEl.style.display = 'none'; }
            descriptionEl.innerHTML = product.description ? product.description.substring(0, 250) + '...' : '';
            viewFullLink.href = '/products/' + handle;
            if (product.featured_image) { mainImage.src = product.featured_image; mainImage.alt = product.title; }
            thumbnailsContainer.innerHTML = '';
            product.images.forEach((img, index) => {
              const thumb = document.createElement('img');
              thumb.src = getSizedImageUrl(img, '100x100');
              thumb.alt = product.title;
              thumb.className = 'ptq-modal-thumbnail' + (index === 0 ? ' active' : '');
              thumb.addEventListener('click', () => {
                mainImage.src = img;
                thumbnailsContainer.querySelectorAll('.ptq-modal-thumbnail').forEach(t => t.classList.remove('active'));
                thumb.classList.add('active');
              });
              thumbnailsContainer.appendChild(thumb);
            });
            variantsEl.innerHTML = '';
            if (product.variants.length > 1) {
              product.options.forEach((option, optionIndex) => {
                const group = document.createElement('div');
                group.className = 'ptq-variant-group';
                const label = document.createElement('label');
                label.textContent = option;
                group.appendChild(label);
                const opts = document.createElement('div');
                opts.className = 'ptq-variant-options';
                const values = [...new Set(product.variants.map(v => v.options[optionIndex]))];
                values.forEach(value => {
                  const optBtn = document.createElement('button');
                  optBtn.type = 'button';
                  optBtn.className = 'ptq-variant-option';
                  optBtn.textContent = value;
                  optBtn.addEventListener('click', () => {
                    opts.querySelectorAll('.ptq-variant-option').forEach(b => b.classList.remove('selected'));
                    optBtn.classList.add('selected');
                    updateSelectedVariant();
                  });
                  opts.appendChild(optBtn);
                });
                group.appendChild(opts);
                variantsEl.appendChild(group);
              });
              variantsEl.querySelectorAll('.ptq-variant-options').forEach(group => {
                const firstOption = group.querySelector('.ptq-variant-option');
                if (firstOption) firstOption.classList.add('selected');
              });
              updateSelectedVariant();
            } else { selectedVariantId = product.variants[0].id; }
            quantityInput.value = 1;
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
            isQuickViewOpen    = true;
            isQuickViewLoading = false;
          })
          .catch(err => { console.error('PTQ quickview error:', err); isQuickViewLoading = false; });
      }

      function updateSelectedVariant() {
        if (!currentProduct) return;
        const selectedOptions = [];
        variantsEl.querySelectorAll('.ptq-variant-options').forEach(group => {
          const selected = group.querySelector('.ptq-variant-option.selected');
          if (selected) selectedOptions.push(selected.textContent);
        });
        const variant = currentProduct.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
        if (variant) {
          selectedVariantId = variant.id;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML = fmtMoney(variant.price) + '<span class="compare">' + fmtMoney(variant.compare_at_price) + '</span>';
          } else { priceEl.innerHTML = fmtMoney(variant.price); }
          if (variant.featured_image) mainImage.src = variant.featured_image.src;
        }
      }

      function closeModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
        isQuickViewOpen   = false;
        currentProduct    = null;
        selectedVariantId = null;
      }

      closeBtn.addEventListener('click', closeModal, { signal: abortSignal });
      overlay.addEventListener('click', closeModal, { signal: abortSignal });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isQuickViewOpen) closeModal(); }, { signal: abortSignal });

      modal.querySelector('.ptq-qty-minus')?.addEventListener('click', () => {
        const current = parseInt(quantityInput.value);
        if (current > 1) quantityInput.value = current - 1;
      }, { signal: abortSignal });

      modal.querySelector('.ptq-qty-plus')?.addEventListener('click', () => {
        quantityInput.value = parseInt(quantityInput.value) + 1;
      }, { signal: abortSignal });

      document.addEventListener('click', function (e) {
        const quickviewBtn = e.target.closest('.ptq-quickview-btn');
        if (!quickviewBtn) return;
        if (quickviewBtn.dataset.sectionId !== SECTION_ID) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const handle = quickviewBtn.dataset.productHandle;
        if (handle && !isQuickViewLoading && !isQuickViewOpen) openQuickView(handle);
      }, { signal: abortSignal, capture: true });

      addToCartBtn?.addEventListener('click', async function () {
        if (isModalAdding || this.disabled || !selectedVariantId) return;
        isModalAdding = true;
        const quantity     = parseInt(quantityInput.value);
        const originalText = this.textContent;
        this.textContent = ADDING_TEXT;
        this.disabled = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: parseInt(selectedVariantId), quantity })
          });
          if (response.ok) {
            this.textContent = '✓ ' + ADDED_TEXT;
            openROACartDrawer();
            setTimeout(() => { this.textContent = originalText; this.disabled = false; isModalAdding = false; closeModal(); }, 1500);
          } else { this.textContent = originalText; this.disabled = false; isModalAdding = false; }
        } catch (e) { this.textContent = originalText; this.disabled = false; isModalAdding = false; }
      }, { signal: abortSignal });

      document.addEventListener('click', async function (e) {
        const addBtn = e.target.closest('.ptq-add-btn');
        if (!addBtn) return;
        if (addBtn.dataset.sectionId !== SECTION_ID) return;
        e.preventDefault(); e.stopPropagation();
        if (addBtn.disabled || addBtn.dataset.adding === 'true') return;
        addBtn.dataset.adding = 'true';
        const variantId = addBtn.dataset.variantId;
        if (!variantId) { addBtn.dataset.adding = 'false'; return; }
        const originalText = addBtn.innerHTML;
        addBtn.innerHTML = ADDING_TEXT;
        addBtn.disabled  = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          });
          if (response.ok) {
            addBtn.innerHTML = '✓ ' + ADDED_TEXT;
            openROACartDrawer();
            setTimeout(() => { addBtn.innerHTML = originalText; addBtn.disabled = false; addBtn.dataset.adding = 'false'; }, 2000);
          } else { addBtn.innerHTML = originalText; addBtn.disabled = false; addBtn.dataset.adding = 'false'; }
        } catch (e) { addBtn.innerHTML = originalText; addBtn.disabled = false; addBtn.dataset.adding = 'false'; }
      }, { signal: abortSignal });

      function openROACartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer#drawerMode');
        if (!cartDrawer) return;
        fetch('/?sections=cart-drawer').then(res => res.json()).then(sections => {
          if (sections['cart-drawer']) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = sections['cart-drawer'];
            const newCartDrawer = tempDiv.querySelector('cart-drawer#drawerMode');
            if (newCartDrawer) {
              const currentInner = cartDrawer.querySelector('.drawer__inner');
              const newInner     = newCartDrawer.querySelector('.drawer__inner');
              if (currentInner && newInner) currentInner.innerHTML = newInner.innerHTML;
              if (newCartDrawer.classList.contains('is-empty')) cartDrawer.classList.add('is-empty');
              else cartDrawer.classList.remove('is-empty');
            }
          }
          openDrawerNow();
        }).catch(() => openDrawerNow());

        function openDrawerNow() {
          if (typeof cartDrawer.open === 'function') { cartDrawer.open(); return; }
          cartDrawer.classList.add('active');
          const drawerEl = cartDrawer.querySelector('.drawer');
          if (drawerEl) drawerEl.style.visibility = 'visible';
          document.body.classList.add('overflow-hidden');
        }
        updateCartBubble();
      }

      function updateCartBubble() {
        fetch('/cart.js').then(res => res.json()).then(cart => {
          ['.cart-count-bubble span', '[data-cart-count]', '.cart-count', '#cart-icon-bubble span', '.header__cart-count'].forEach(sel => {
            document.querySelectorAll(sel).forEach(el => {
              el.textContent = cart.item_count;
              const bubble = el.closest('.cart-count-bubble');
              if (bubble && cart.item_count > 0) { bubble.classList.remove('hidden'); bubble.style.display = ''; }
            });
          });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  // Queue bootstrap
  var queue = window._PTQ;
  window._PTQ = { push: _initPTQ };
  if (Array.isArray(queue)) queue.forEach(_initPTQ);
})();
